module.exports = "/wp-content/themes/onnit/script/cart/dist/emoji-slightly-frowning-face-1c4ce339.png";